// extracted by mini-css-extract-plugin
module.exports = {"contactSection":"ContactComponent-module__contactSection","wrapper":"ContactComponent-module__wrapper","anyQustWrapper":"ContactComponent-module__anyQustWrapper"};